// The Dashboard landing pane (Brief 4 / P8; Brief 5 #1) — the calm
// overview you arrive on, now a CROSS-PROJECT needs-me triage: "which one needs
// me, in two seconds". The verdict line states the count; then EVERY needs-me
// session is listed flat (across all projects) as the same SessionCell the
// project view uses, longest-waiting first — so the most-overdue session is what
// the eye lands on and one click drops you into it. Everything that's handled
// collapses to a single calm "N others handled" line beneath, never competing.
// At rest (nothing needs you) the verdict is POSITIVELY rendered ("All sessions
// handled"), never an empty screen — calm is designed, not absence.
//
// It REUSES the presence spine: the one presence context (the sessions list),
// `orderSessions` (longest-waiting first), `isNeedsInput`, and the SessionCell —
// no second source, no new ordering. The left sidebar is still the way into a
// specific project.

import { usePresenceContext, isNeedsInput, orderSessions } from "@waytide/ui";
import { SessionCell } from "./sessions/SessionCell";

export function DashboardHome() {
  const { sessions, needsCount, loaded, error } = usePresenceContext();
  // Every needs-me session, flat across projects, longest-waiting first.
  // `orderSessions` already sorts needs-input to the top by oldest `updated_at`;
  // filtering to needs-input leaves exactly that ordering.
  const needs = orderSessions(sessions).filter((s) => isNeedsInput(s.status));
  const handledCount = sessions.length - needs.length;
  const nowMs = Date.now();

  const sub = error
    ? "Couldn't reach your sessions."
    : !loaded
      ? "Reading your sessions…"
      : needsCount > 0
        ? `${needsCount} session${needsCount === 1 ? " needs" : "s need"} you.`
        : "All sessions handled.";

  return (
    <div className="wt-dash-pane wt-dash-home">
      <header className="wt-dash-pane__head">
        <h1 className="wt-dash-pane__title">Dashboard</h1>
        <p className="wt-dash-pane__sub">{sub}</p>
      </header>

      {needs.length > 0 ? (
        <>
          {/* The triage list: every needs-me session, the longest-waiting first
              (the same cell as the project view). */}
          <div
            className="wt-session-grid wt-dash-home__needs"
            data-testid="home-needs-grid"
          >
            {needs.map((s) => (
              <SessionCell key={s.thread_id} session={s} nowMs={nowMs} />
            ))}
          </div>
          {handledCount > 0 ? (
            <p className="wt-dash-empty wt-dash-home__handled">
              {handledCount} other{handledCount === 1 ? "" : "s"} handled.
            </p>
          ) : null}
        </>
      ) : (
        <p className="wt-dash-empty">
          {loaded && !error
            ? "Nothing needs you right now. Open the Global room for general chat, or pick a project on the left."
            : "Open the Global room for general chat, or pick a project on the left to see its sessions."}
        </p>
      )}
    </div>
  );
}
